import React, {Component} from 'react';
import {Card, Table, Input, Select, Row, Col} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import {SelectValue} from 'antd/lib/select';

import {ParsedListMembership} from '../../../../interfaces';

const {Option} = Select;

interface Properties {
  dataSource: Array<ParsedListMembership>;
  columns: Array<ColumnProps<ParsedListMembership>>;
}

interface State {
  filterActive: boolean;
  filterOSP: boolean;
  filterString: string;
}

class MembershipList extends Component<Properties, State> {
  private readonly DEFAULT_STATE: State = {
    filterActive: null,
    filterOSP: null,
    filterString: '',
  };

  constructor(props: Properties) {
    super(props);
    this.state = this.DEFAULT_STATE;
  }

  changeString = (e: React.ChangeEvent<HTMLInputElement>) => this.setState({filterString: e.target.value});

  getValue(value: string) {
    switch (value) {
      case 'true':
        return true;
      case 'false':
        return false;
      default:
        return null;
    }
  }

  changeActive = (value: SelectValue) => this.setState({filterActive: this.getValue(value.toString())});

  changeOSP = (value: SelectValue) => this.setState({filterOSP: this.getValue(value.toString())});

  getFilteredDatasource(dataSource: Array<ParsedListMembership>): Array<ParsedListMembership> {
    const {filterString, filterActive, filterOSP} = this.state;
    let result: Array<ParsedListMembership> = dataSource;

    if (filterString) {
      result = result.filter(x => x.title.toLowerCase().includes(filterString.toLowerCase()) || x.code.toLowerCase().includes(filterString.toLowerCase()));
    }

    if (filterActive !== null) {
      result = result.filter(x => x.active === filterActive);
    }

    if (filterOSP !== null) {
      result = result.filter(x => x.ospAvailable === filterOSP);
    }

    return result;
  }

  render() {
    const {dataSource, columns} = this.props;
    return (
      <>
        <Card bodyStyle={{padding: 10}} style={{marginBottom: 10}}>
          <Row gutter={24}>
            <Col md={16}>
              <label>Filter memberships</label>
              <Input value={this.state.filterString} onChange={this.changeString} placeholder={'Filter memberships'} />
            </Col>
            <Col md={4}>
              <label>Status</label>
              <Select value={`${this.state.filterActive}`} onChange={this.changeActive} style={{width: '100%'}}>
                <Option value={'null'}>&nbsp;</Option>
                <Option value={'true'}>Active</Option>
                <Option value={'false'}>Inactive</Option>
              </Select>
            </Col>
            <Col md={4}>
              <label>Available in OSP</label>
              <Select value={`${this.state.filterOSP}`} onChange={this.changeOSP} style={{width: '100%'}}>
                <Option value={'null'}>&nbsp;</Option>
                <Option value={'true'}>Available</Option>
                <Option value={'false'}>Not available</Option>
              </Select>
            </Col>
          </Row>
        </Card>
        <Card bodyStyle={{padding: 10}} style={{marginBottom: 10}}>
          <Col md={12}>
            <div className={'list-description-block'} style={{marginTop:0}}>
            <ul>
            <li style={{backgroundColor:'#fdf8e2'}}>Yellow membership had never been configured.</li>
            <li style={{backgroundColor:'#f2dede'}} >Red memberships had been dropped from CRM (Unit4/Exerp..).</li>
            </ul>
            </div>
            </Col>
            </Card>
        <Card bodyStyle={{padding: 0}}>
          <Table
            style={{background: '#fff'}}
            dataSource={this.getFilteredDatasource(dataSource).sort((a: ParsedListMembership, b: ParsedListMembership) => b.priority - a.priority)}
            columns={columns}
            pagination={false}
            rowClassName={(record: ParsedListMembership) => (record.title ? (record.price ? '' : 'noPrice') : 'noTitle')}
          />
        </Card>
      </>
    );
  }
}

export default MembershipList;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipList/components/MembershipList/MembershipList.tsx